import React, { Component } from 'react';
// Header and Footer components removed for standalone use
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import HELPERS from '../../utils/helper';
import { ToastMessage, Toast, toastMsgConfig } from '../toast';
import apis from '../../config/apis';
import { ErrorMessageHandling } from '../error';
import { getClientConfig } from '../../config/clientConfig';
import './template7.css';

class EnquiryTemplate7 extends Component {
  constructor(props) {
    super(props);

    // Get client configuration
    const clientConfig = getClientConfig(props.clientId);

    // If config is null, it means invalid client ID (should be caught by routing)
    if (!clientConfig) {
      this.state = {
        loader: false,
        clientConfig: null,
        formData: {},
        errors: {},
        disabled: true,
        areas: [],
        courses: [],
        qualifications: []
      };
      return;
    }

    this.state = {
      loader: false,
      formData: {
        name: '',
        phone: '',
        email: '',
        city: '',
        cityName: '',
        area: '',
        course: '',
        qualification: '',
        experience: '',
        message: ''
      },
      errors: {},
      disabled: false,
      cities: [],
      areas: [],
      clientConfig: clientConfig,
      courses: clientConfig.courses,
      qualifications: [
        'High School',
        '12th/Intermediate',
        'Diploma',
        "Bachelor's Degree",
        "Master's Degree",
        'PhD',
        'Other'
      ]
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.fetchCities();
    this.fetchCourses();
  }

  fetchCities = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*'
        }
      };

      const citiesUrl = apis.getCitiesUrl(clientConfig);
      const res = await HELPERS.ApiCall(citiesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data && res.data.statusCode === 200) {
        const result = res.data.result;
        const cities = [];

        if (Array.isArray(result)) {
          result.forEach(item => {
            if (item.cityList && Array.isArray(item.cityList)) {
              item.cityList.forEach(cityObj => {
                if (cityObj.city_name && cityObj.city_id) {
                  cities.push({
                    id: cityObj.city_id,
                    name: cityObj.city_name
                  });
                }
              });
            }
          });
        }

        if (cities.length > 0) {
          this.setState({ cities });
        }
      }
    } catch (err) {
      console.error('Error fetching cities:', err);
    }
  }

  fetchAreas = async (cityId = null) => {
    try {
      const { clientConfig, formData } = this.state;

      // Use the provided cityId or get it from formData
      const selectedCityId = cityId || formData.city;

      if (!selectedCityId) {
        // If no city is selected, reset areas
        this.setState({ areas: [] });
        return;
      }

      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*'
        }
      };

      // Build URL with selected city ID
      const areasUrl = `${clientConfig.api.baseUrl}/StdMgmtWebAPI/api/v1/cityArea/area/${clientConfig.instituteId}?city_ids=${selectedCityId}`;
      const res = await HELPERS.ApiCall(areasUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data) {
        const result = res.data.result || res.data.data || res.data;
        const areas = [];

        if (Array.isArray(result)) {
          result.forEach(item => {
            if (item.areaList && Array.isArray(item.areaList)) {
              item.areaList.forEach(areaObj => {
                if (areaObj.area) {
                  areas.push(areaObj.area);
                }
              });
            }
          });
        }

        if (areas.length > 0) {
          this.setState({ areas });
        } else {
          this.useFallbackAreas();
        }
      } else {
        this.useFallbackAreas();
      }
    } catch (err) {
      console.error('Error fetching areas:', err);
      this.useFallbackAreas();
    }
  }

  useFallbackAreas = () => {
    this.setState({
      areas: []
    });
  }

  fetchCourses = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*',
        }
      };

      const coursesUrl = apis.getCoursesUrl(clientConfig);
      const res = await HELPERS.ApiCall(coursesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data) {
        const courseList = res.data.data || res.data;
        const courses = [];

        if (Array.isArray(courseList)) {
          courseList.forEach(item => {
            if (item.master_course) {
              courses.push(item.master_course);
            }
          });
        }

        if (courses.length > 0) {
          this.setState({ courses });
        } else {
          this.useFallbackCourses();
        }
      } else {
        this.useFallbackCourses();
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
      this.useFallbackCourses();
    }
  }

  useFallbackCourses = () => {
    // Use courses from clientConfig as fallback
    const { clientConfig } = this.state;
    if (clientConfig && clientConfig.courses) {
      this.setState({ courses: clientConfig.courses });
    }
  }

  showMessage = (type, message) => {
    Toast(message, toastMsgConfig(type));
  }

  handleInputChange = (field, value, additionalData = {}) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [field]: value,
        ...additionalData
      },
      errors: {
        ...this.state.errors,
        [field]: ''
      }
    }, () => {
      // Fetch areas when city is selected
      if (field === 'city') {
        // Reset area when city changes
        this.setState({
          formData: {
            ...this.state.formData,
            city: value,
            cityName: additionalData.cityName || '',
            area: ''
          }
        });
        this.fetchAreas(value);
      }
    });
  }

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = 'Full name is required';
    } else if (formData.name.trim().length < 2) {
      errors.name = 'Name must be at least 2 characters';
    }

    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^[0-9]{10}$/.test(formData.phone.replace(/\s/g, ''))) {
      errors.phone = 'Please enter a valid 10-digit phone number';
    }

    if (formData.email.trim() && !HELPERS.validateEmail(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    if (!formData.city) {
      errors.city = 'City is required';
    }

    if (!formData.area.trim()) {
      errors.area = 'Area/Location is required';
    }

    if (!formData.course) {
      errors.course = 'Please select a program of interest';
    }

    if (!formData.message.trim()) {
      errors.message = 'Please tell us about your goals and interests';
    } else if (formData.message.trim().length < 20) {
      errors.message = 'Please provide more details (at least 20 characters)';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  handleSubmit = async () => {
    this.setState({ disabled: true });

    // Check rate limiting - max 3 submissions per minute
    if (!HELPERS.checkRateLimit('form_submission', 3, 60000)) {
      this.setState({ disabled: false });
      this.showMessage('e', 'Too many submissions. Please wait a minute before trying again.');
      return;
    }

    if (!this.validateForm()) {
      this.setState({ disabled: false });
      this.showMessage('e', 'Please correct the errors in the form');
      return;
    }

    this.setState({ loader: true });

    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Authorization': clientConfig.api.authorization,
          'Content-Type': 'application/json',
          'source': 'WEB',
          'accept': 'application/json, text/plain, */*'
        }
      };

      const payload = {
        name: this.state.formData.name,
        mobile: this.state.formData.phone,
        email: this.state.formData.email || '',
        comments: this.state.formData.message,
        institute_id: clientConfig.instituteId,
        customComponentList: [],
        mCourseName: this.state.formData.course || '',
        state: clientConfig.api.defaults.state,
        city: this.state.formData.cityName || clientConfig.api.defaults.city,
        area: this.state.formData.area || clientConfig.api.defaults.defaultArea
      };

      const apiUrl = apis.getApiUrl(clientConfig);
      const res = await HELPERS.ApiCall(apiUrl, payload, 'POST', 'proctur', headers);
      
      if (res.status === 200 && res.data.statusCode === 200) {
        this.setState({
          loader: false,
          formData: {
            name: '',
            phone: '',
            email: '',
            city: '',
            cityName: '',
            area: '',
            course: '',
            qualification: '',
            experience: '',
            message: ''
          },
          disabled: false,
          errors: {},
          areas: []
        });
        this.showMessage('s', 'Registration submitted successfully! Our admissions team will contact you within 24 hours.');
      } else {
        this.showMessage('e', res.data.message || 'Something went wrong. Please try again.');
        this.setState({ loader: false, disabled: false });
      }
    } catch (err) {
      if (err.response && err.response.status === 403) {
        this.props.dispatch({ 
          type: 'LOGOUT', 
          message: err.response.data?.message || 'Session expired' 
        });
      } else {
        this.showMessage('e', ErrorMessageHandling(err));
      }
      this.setState({ loader: false, disabled: false });
    }
  }

  render() {
    const { formData, errors, disabled, loader, cities, areas, courses, qualifications, clientConfig } = this.state;

    return (
      <>
        {loader && (
          <div className="template7-loader">
            <div className="template7-loading-spinner"></div>
            <p>Submitting your enquiry...</p>
          </div>
        )}
        <ToastMessage />

        <div className="template7-page">
          {/* Hero Section */}
          <div className="template7-hero">
            <div className="template7-hero-container">
              <div className="template7-hero-content">
                <div className="template7-brand-section">
                  <div className="template7-logo">
                    <img src={clientConfig.branding.logo} alt={clientConfig.clientName + " Logo"} />
                  </div>
                </div>
                <div className="template7-hero-badge">
                  <i className="fa fa-star"></i>
                  <span>{clientConfig.branding.badgeText}</span>
                </div>
                <h1 className="template7-hero-title">
                  {clientConfig.branding.heroTitle}
                </h1>
                <p className="template7-hero-subtitle">
                  {clientConfig.branding.heroSubtitle}
                </p>

                <div className="template7-hero-stats">
                  <div className="template7-stat-item">
                    <div className="template7-stat-number">{clientConfig.stats.alumni}</div>
                    <div className="template7-stat-label">Alumni Network</div>
                  </div>
                  <div className="template7-stat-item">
                    <div className="template7-stat-number">{clientConfig.stats.experience}</div>
                    <div className="template7-stat-label">Years Experience</div>
                  </div>
                  <div className="template7-stat-item">
                    <div className="template7-stat-number">{clientConfig.stats.placement}</div>
                    <div className="template7-stat-label">Placement</div>
                  </div>
                  <div className="template7-stat-item">
                    <div className="template7-stat-number">{clientConfig.stats.partners}</div>
                    <div className="template7-stat-label">Industry Partners</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form Section */}
          <div className="template7-contact-section">
            <div className="template7-container">
              <div className="template7-contact-content">
                {/* Left Side - Information */}
                <div className="template7-info-section">
                  <div className="template7-section-header">
                    <h2>Admission Information</h2>
                    <p>Start your creative journey with India's leading design institute. Our admission counselors will guide you through the enrollment process.</p>
                  </div>

                  <div className="template7-contact-info">
                    <div className="template7-contact-item">
                      <div className="template7-contact-icon">
                        <i className="fa fa-map-marker"></i>
                      </div>
                      <div className="template7-contact-details">
                        <h4>Visit Our Campus</h4>
                        <p>{clientConfig.contactInfo.address}</p>
                      </div>
                    </div>

                    <div className="template7-contact-item">
                      <div className="template7-contact-icon">
                        <i className="fa fa-phone"></i>
                      </div>
                      <div className="template7-contact-details">
                        <h4>Call Us</h4>
                        <p>{clientConfig.contactInfo.phone1}<br />{clientConfig.contactInfo.phone2}</p>
                      </div>
                    </div>

                    <div className="template7-contact-item">
                      <div className="template7-contact-icon">
                        <i className="fa fa-envelope"></i>
                      </div>
                      <div className="template7-contact-details">
                        <h4>Email Us</h4>
                        <p>{clientConfig.contactInfo.email}</p>
                      </div>
                    </div>

                    <div className="template7-contact-item">
                      <div className="template7-contact-icon">
                        <i className="fa fa-globe"></i>
                      </div>
                      <div className="template7-contact-details">
                        <h4>Website</h4>
                        <p>{clientConfig.contactInfo.website}</p>
                      </div>
                    </div>
                  </div>

                  <div className="template7-features-list">
                    <h3>Why Choose {clientConfig.clientName}?</h3>
                    <div className="template7-features-grid">
                      {clientConfig.features.map((feature, index) => (
                        <div key={index} className="template7-feature-item">
                          <i className="fa fa-check-circle"></i>
                          <span>{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Right Side - Form */}
                <div className="template7-form-section">
                  <div className="template7-form-container">
                    <div className="template7-form-header">
                      <h3>Student Registration Form</h3>
                      <p>Begin your design journey - Fill out the registration form and our admissions team will contact you within 24 hours</p>
                    </div>

                    <form className="template7-form" onSubmit={(e) => e.preventDefault()}>
                      <div className="template7-form-group">
                        <label className="template7-label">Name *</label>
                        <input
                          type="text"
                          className={`template7-input ${errors.name ? 'template7-error' : ''}`}
                          placeholder="Enter your full name"
                          value={formData.name}
                          onChange={(e) => this.handleInputChange('name', e.target.value)}
                        />
                        {errors.name && <span className="template7-error-text">{errors.name}</span>}
                      </div>

                      <div className="template7-form-row">
                        <div className="template7-form-group template7-half">
                          <label className="template7-label">Phone *</label>
                          <input
                            type="tel"
                            className={`template7-input ${errors.phone ? 'template7-error' : ''}`}
                            placeholder="10-digit mobile number"
                            value={formData.phone}
                            onChange={(e) => {
                              const value = e.target.value.replace(/[^0-9]/g, '');
                              if (value.length <= 10) {
                                this.handleInputChange('phone', value);
                              }
                            }}
                          />
                          {errors.phone && <span className="template7-error-text">{errors.phone}</span>}
                        </div>

                        <div className="template7-form-group template7-half">
                          <label className="template7-label">Email</label>
                          <input
                            type="email"
                            className={`template7-input ${errors.email ? 'template7-error' : ''}`}
                            placeholder="your.email@example.com (optional)"
                            value={formData.email}
                            onChange={(e) => this.handleInputChange('email', e.target.value)}
                          />
                          {errors.email && <span className="template7-error-text">{errors.email}</span>}
                        </div>
                      </div>

                      <div className="template7-form-row">
                        <div className="template7-form-group template7-half">
                          <label className="template7-label">City *</label>
                          <select
                            className={`template7-input ${errors.city ? 'template7-error' : ''}`}
                            value={formData.city}
                            onChange={(e) => {
                              const selectedCity = cities.find(city => city.id === parseInt(e.target.value));
                              this.handleInputChange('city', e.target.value, {
                                cityName: selectedCity ? selectedCity.name : ''
                              });
                            }}
                          >
                            <option value="">Select your city</option>
                            {cities.map((city, index) => (
                              <option key={index} value={city.id}>
                                {city.name}
                              </option>
                            ))}
                          </select>
                          {errors.city && <span className="template7-error-text">{errors.city}</span>}
                        </div>

                        <div className="template7-form-group template7-half">
                          <label className="template7-label">Area *</label>
                          <select
                            className={`template7-input ${errors.area ? 'template7-error' : ''}`}
                            value={formData.area}
                            onChange={(e) => this.handleInputChange('area', e.target.value)}
                            disabled={!formData.city}
                          >
                            <option value="">
                              {formData.city ? 'Select your area' : 'Please select city first'}
                            </option>
                            {areas.map((area, index) => (
                              <option key={index} value={area}>
                                {area}
                              </option>
                            ))}
                          </select>
                          {errors.area && <span className="template7-error-text">{errors.area}</span>}
                        </div>
                      </div>

                      <div className="template7-form-row">
                        <div className="template7-form-group template7-half">
                          <label className="template7-label">Course *</label>
                          <select
                            className={`template7-input ${errors.course ? 'template7-error' : ''}`}
                            value={formData.course}
                            onChange={(e) => this.handleInputChange('course', e.target.value)}
                          >
                            <option value="">Select design program</option>
                            {courses.map((course, index) => (
                              <option key={index} value={course}>
                                {course}
                              </option>
                            ))}
                          </select>
                          {errors.course && <span className="template7-error-text">{errors.course}</span>}
                        </div>
                      </div>


                      <div className="template7-form-group">
                        <label className="template7-label">Tell us about your design interests and career goals *</label>
                        <textarea
                          className={`template7-input template7-textarea ${errors.message ? 'template7-error' : ''}`}
                          placeholder="Share your creative interests, design career goals, preferred specialization, or any questions about our design programs..."
                          rows="4"
                          value={formData.message}
                          onChange={(e) => this.handleInputChange('message', e.target.value)}
                        />
                        {errors.message && <span className="template7-error-text">{errors.message}</span>}
                      </div>

                      <div className="template7-form-actions">
                        <button
                          type="button"
                          className={`template7-submit-btn ${disabled ? 'template7-disabled' : ''}`}
                          onClick={this.handleSubmit}
                          disabled={disabled}
                        >
                          <i className="fa fa-paper-plane"></i>
                          {loader ? 'Submitting...' : 'Submit Registration'}
                        </button>
                      </div>

                      <div className="template7-form-footer">
                        <div className="template7-privacy-note">
                          <i className="fa fa-shield"></i>
                          <span>Your information is completely secure and confidential</span>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...state.home,
  ...state.auth
});

const ConnectedEnquiryTemplate7 = connect(mapStateToProps)(EnquiryTemplate7);

// Wrapper component to use React Router hooks
function EnquiryTemplate7WithRouter(props) {
  const { clientId } = useParams();
  return <ConnectedEnquiryTemplate7 {...props} clientId={clientId} />;
}

export default EnquiryTemplate7WithRouter;